if (!window.Eurus.loadedScript.has('product-comparison.js')) {
  window.Eurus.loadedScript.add('product-comparison.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductComparisonPopup', {
        loadTablet(el, url) {
          if(url) {
            fetch(url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-comparison-table');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  requestAnimationFrame(() => {
                    el.innerHTML = recommendations.innerHTML;
                    el.querySelectorAll('.content-tablet').forEach((item) => {
                      if (el.querySelector('.'+item.dataset.selectHtml)) {
                        el.querySelector('.'+item.dataset.selectHtml).innerHTML += item.innerHTML;
                      }
                    });
                    // Las fuentes dentro de .content-tablet quedan ocultas: arrancarlas
                    // duplicaria las descargas de Trustpilot que este lazy evita.
                    el.querySelectorAll('.trustpilot-widget, .trustpilot-widget-lazy').forEach((w) => {
                      if (w.closest('.content-tablet')) return;
                      w.classList.remove('trustpilot-widget-lazy');
                      w.classList.add('trustpilot-widget');
                      if (window.Trustpilot) window.Trustpilot.loadFromElement(w, true);
                    });
                  });
                }
              }).catch(e => {console.error(e);});
          }else {
            el.querySelectorAll('.content-tablet').forEach((item) => {
              if (el.querySelector('.'+item.dataset.selectHtml)) {
                el.querySelector('.'+item.dataset.selectHtml).innerHTML += item.innerHTML;
              }
            });
            el.querySelectorAll('.trustpilot-widget, .trustpilot-widget-lazy').forEach((w) => {
              if (w.closest('.content-tablet')) return;
              w.classList.remove('trustpilot-widget-lazy');
              w.classList.add('trustpilot-widget');
              if (window.Trustpilot) window.Trustpilot.loadFromElement(w, true);
            });
          }
        }
      });
    })
  });
}    